import React from 'react';

export const PowerBISearchResultIcon = (): React.JSX.Element => {
	return (
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect width="32" height="32" rx="8" fill="white" />
			<rect
				x="0.508324"
				y="0.508324"
				width="30.9834"
				height="30.9834"
				rx="7.49168"
				stroke="#0B1228"
				strokeOpacity="0.14"
				strokeWidth="1.01665"
			/>
			<path
				d="M23.2042 5.3335H17.5491C17.0629 5.3335 16.6687 5.72768 16.6687 6.21392V25.7864C16.6687 26.2727 17.0629 26.6668 17.5491 26.6668H23.2042C23.6904 26.6668 24.0846 26.2727 24.0846 25.7864V6.21392C24.0846 5.72768 23.6904 5.3335 23.2042 5.3335Z"
				fill="#B25400"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M19.7162 25.7862V26.6666H13.1807C12.6945 26.6666 12.3003 26.2724 12.3003 25.7862V11.5301C12.3003 11.0438 12.6945 10.6497 13.1807 10.6497H18.8357C19.322 10.6497 19.7162 11.0438 19.7162 11.5301V25.7862Z"
				fill="#DE9800"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M19.7162 25.7862V26.6666H13.1807C12.6945 26.6666 12.3003 26.2724 12.3003 25.7862V11.5301C12.3003 11.0438 12.6945 10.6497 13.1807 10.6497H18.8357C19.322 10.6497 19.7162 11.0438 19.7162 11.5301V25.7862Z"
				fill="#DE9800"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.4159 25.7862V26.6667H8.88042C8.39416 26.6667 8 26.2725 8 25.7862V16.8804C8 16.3942 8.39416 16 8.88042 16H14.5354C15.0217 16 15.4159 16.3942 15.4159 16.8804V25.7862Z"
				fill="#F3CD32"
			/>
		</svg>
	);
};
